import { useState } from 'react';
import { Link } from 'react-router-dom';
import { api } from '../services/api';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [sent, setSent] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    setSubmitting(true);

    try {
      await api.post('/auth/password/reset-request', { email });
      setSent(true);
    } catch (err) {
      setError(err.message || 'Une erreur est survenue');
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center th-bg px-4 transition-colors duration-300">
      <div className="w-full max-w-sm animate-fadeInUp">
        <div className="text-center mb-8">
          <Link to="/" className="font-mono font-bold text-2xl text-accent tracking-[0.15em]">STRIDERR</Link>
          <p className="mt-2 text-sm th-text-secondary">Mot de passe oublié</p>
        </div>

        {sent ? (
          <div className="border th-border p-6 th-bg-surface transition-colors duration-300">
            <p className="text-sm th-text">
              Si un compte existe avec cet email, un lien de réinitialisation a été envoyé.
              Pense à vérifier tes spams.
            </p>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="border th-border p-6 space-y-6 th-bg-surface transition-colors duration-300">
            {error && (
              <div className="border border-status-rejected/30 text-status-rejected px-3 py-2 text-sm font-mono">
                {error}
              </div>
            )}

            <p className="text-sm th-text-secondary">
              Entre ton email, on t'enverra un lien pour réinitialiser ton mot de passe.
            </p>

            <div>
              <label htmlFor="email" className="block text-xs font-mono th-text-secondary mb-2 uppercase tracking-widest">
                Email
              </label>
              <input
                id="email"
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="th-input"
                placeholder="ton@email.com"
              />
            </div>

            <button
              type="submit"
              disabled={submitting}
              className="w-full th-btn-accent"
            >
              {submitting ? 'Envoi...' : 'Envoyer le lien'}
            </button>
          </form>
        )}

        <p className="text-center mt-6 text-sm th-text-muted">
          <Link to="/login" className="text-accent hover:opacity-70 transition-opacity duration-150 font-mono">
            Retour à la connexion
          </Link>
        </p>
      </div>
    </div>
  );
}
